import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { RouterManager } from "./router";
import {
  AuthProvider,
  PermissionsProvider,
  NotificationsProvider,
} from "./contexts";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <PermissionsProvider>
            <NotificationsProvider>
              <RouterManager />
            </NotificationsProvider>
          </PermissionsProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
